// extracted by mini-css-extract-plugin
module.exports = {"toggle-container":"a10a3f92e9--toggle-container--VOQ8b","mobile":"a10a3f92e9--mobile--WX3No","label":"a10a3f92e9--label--LSePh"};